export default "__VITE_ASSET__DDbVe0dG__"